import {
  	CLEAR_MESSAGE
} from './types';

import MessageUtils from "../utils/MessageUtils";

export const dispatchSuccessMessage = (message) => {
    return (dispatch) => {
        MessageUtils.dispatchSuccessMessage(dispatch, message);
    }
};

export const dispatchErrorMessage = (message) => {
    return (dispatch) => {
        MessageUtils.dispatchErrorMessage(dispatch, message);
    }
};

export const clearMessage = () => {
	return {
    	type: CLEAR_MESSAGE
  	};
};



// WEBPACK FOOTER //
// ./src/actions/MessageActions.js